import React, { Fragment } from 'react'
import styled from 'styled-components'

const Green = styled.span`
  color: green;
`
const Red = styled.span`
  color: red;
`
const Link = styled.a`
  cursor: pointer;
  color: #ce7019;
`

export const formatName = admin => {
  const { shortTermThrottled, genieSettings, name, link } = admin
  const rocketShip = shortTermThrottled ? <i className="fa fa-rocket" /> : null
  if (!genieSettings) {
    return (
      <div>
        <Link href={link}>
          {name}
        </Link>
        {rocketShip}
      </div>
    )
  } else {
    const { outOfOffice } = genieSettings
    return (
      <div>
        <Link href={link}>
          {name}
        </Link>
        {outOfOffice ? ' (Out of Office)' : ''}
        {rocketShip}
      </div>
    )
  }
}
export const formatRole = genieSettings => {
  if (genieSettings) {
    const { preferredLenders, preferredPartners, level } = genieSettings
    const formattedLenders = preferredLenders.join(', ')
    const formattedPartners = preferredPartners.join(', ')
    return (
      <Fragment>
        <span>{level}</span>
        <span>{formattedPartners}</span>
        <span>{formattedLenders}</span>
      </Fragment>
    )
  }
}
export const formatLeftUntilCap = leftUntilCap => {
  if (leftUntilCap > 0) {
    return (
      <div>
        <Green>{leftUntilCap}</Green> left
      </div>
    )
  } else if (leftUntilCap < 0) {
    return (
      <div>
        <Red>{Math.abs(leftUntilCap)}</Red> over
      </div>
    )
  } else {
    return (<div>0</div>)
  }
}
export const formatPercentageOfCap = percentageOfCap => `${Math.round(percentageOfCap * 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}%`
export const formatPortfolioSize = portfolioSize => (portfolioSize / 1000000).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
export const formatAverageSmartRate = averageSmartRate => averageSmartRate.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
